// extracted by mini-css-extract-plugin
export default {"copy":"Hha-z","sizingCopy":"Iha-z","recommendedFitText":"Jha-z"};